import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseLocalRepository } from '@data/base/base-local.repository';
import { Observable } from 'rxjs';
import { ApiResources } from '@constants/api-resources';

@Injectable()
export class GetMunicipiosRepository extends BaseLocalRepository {
  constructor(httpClient: HttpClient) {
    super(httpClient, ApiResources.MUNICIPIOS);
  }
  get(): Observable<any> {
    return this.getRequest<any>(ApiResources.MUNICIPIOS)
  }
}